import Nav from "../../components/UI/Nav";
import { useEffect } from "react";
import { useState } from "react";
import Transition from "../../components/UI/Transition";
import ProjectFooter from "../../components/UI/Footer/ProjectFooter";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

const birthdaySections = [
    {
        title: "Posters",
        description: "Posters in Different Styles, United by One Theme",
        folder: "posters",
        images: ["JAM.png", "Happy Ryan's Day.png", "Ryan's Day.png", "1st + 31st.png"],
    },
    {
        title: "Invitation",
        description: "Produce-Themed Party Invitation Design - For digital and print use.",
        folder: "invitation",
        images: ["Invitation - Welcom 1.png", "Invitation - Date.png", "Invitation - Welcome 2.png","invitation - basket.png"],    
    },
    {
        title: "Card",
        description: "A special first-birthday tradition where the baby chooses an object representing their future career. I created 20 career designs, with a few featured here as a sneak peek.",
        folder: "card",
        images: ["Musician.png", "Judge.png", "Engineer.png", "Architechure.png"],
        imageNames: ["Musician", "Judge", "Engineer", "Architecture"],
    },
    {
        title: "Play Cash",
        description: "Play cash and bill designs for the birthday party activity.",
        folder: "cash",
        images: ["Play Cash - 20.png", "Play Cash - 10.png", "Bill - 10 - back.png", "Bill - 10 - back.png"],
    },
];

const invitationPrints = ["print1.jpg", "print2.jpg"];

export default function BP() {
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);
    const [lightboxImages, setLightboxImages] = useState([]);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    const openLightbox = (images, imageIndex) => {
        setLightboxImages(images);
        setLightboxIndex(imageIndex);
        setLightboxOpen(true);
    };

    return (
        <Transition>
            <div
                style={{ backgroundColor: "#dfe6da" }}
                className="main__container re-padding"
            >
                <div className="menu__fix">
                    <Nav />
                </div>

                <div className="pictok__container">
                    <section className="topContainer">
                        <img
                            src="/assets/projects/bp/gallery.png"
                            alt="B-day Party project gallery"
                            loading="lazy"
                            style={{
                                width: "100%",
                                maxWidth: "50em",
                                objectFit: "contain",
                                borderRadius: "2em",
                            }}
                        />
                    </section>

                    <section className="pictok__mainContainer">
                        <div className="pictok__mainTitle">
                            <h2 style={{ color: "#1f4d3a" }}>Overview</h2>
                        </div>
                        <div className="pictok__mainContent">
                            <p>I originally created this project for my son’s birthday, inspired by the popular produce-themed farm party trend. After the party’s success, I received several inquiries about turning the digital and printable designs into ready-to-use templates and mockups.</p>
                          
                        </div>
                    </section>

                    {birthdaySections.map((section) => (
                        <section className="pictok__mainContainer" key={section.title}>
                            <div className="pictok__mainTitle">
                                <h2 style={{ color: "#1f4d3a" }}>{section.title}</h2>
                            </div>
                            <div className="pictok__mainContent">
                                <p>{section.description}</p>
                                <div
                                    className={`bp__gallery ${section.title === "Play Cash" ? "bp__gallery--playCash" : ""}`}
                                    style={{
                                        display: "grid",
                                        alignItems: "center",
                                        justifyItems: "center",
                                        justifyContent: "center",
                                        gap: "1.5em",
                                        width: "100%",
                                    }}
                                >
                                    {section.images.map((image, imageIndex) => {
                                        const imagePath = `/assets/projects/bp/${section.folder}/${encodeURIComponent(image)}`;

                                        return (
                                            <div
                                                key={`${image}-${imageIndex}`}
                                                style={{
                                                    width: section.title === "Play Cash" ? "100%" : "100%",
                                                    textAlign: "center",
                                                }}
                                            >
                                                <img
                                                    src={imagePath}
                                                    alt={`${section.title} design ${image}`}
                                                    onClick={() => openLightbox(
                                                        section.images.map((sectionImage) => `/assets/projects/bp/${section.folder}/${encodeURIComponent(sectionImage)}`),
                                                        imageIndex
                                                    )}
                                                    style={{
                                                        width: section.title === "Play Cash" ? "28em" : "100%",
                                                        maxWidth: "100%",
                                                        height: section.title === "Play Cash"
                                                            ? "100%"
                                                            : section.title === "Card"
                                                                ? "20em"
                                                                : "16em",
                                                        objectFit: "contain",
                                                        borderRadius: "1em",
                                                        cursor: "zoom-in",
                                                    }}
                                                />
                                                {section.imageNames && (
                                                    <p style={{
                                                        margin: "0.5em 0 0",
                                                        color: "#1f4d3a",
                                                        fontFamily: "inherit",
                                                        textAlign: "center",
                                                        fontWeight: "600",
                                                    }}>
                                                        {section.imageNames[imageIndex]}
                                                    </p>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                                {section.title === "Invitation" && (
                                    <div>
                                        <p style={{
                                            marginTop: "2em",
                                            color: "#1f4d3a",
                                            fontWeight: "600",
                                        }}>
                                            Invitation Prints
                                        </p>
                                        <div
                                            className="bp__gallery"
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                                                alignItems: "center",
                                                justifyItems: "center",
                                                gap: "1.5em",
                                                width: "100%",
                                            }}
                                        >
                                            {invitationPrints.map((print, printIndex) => (
                                                <img
                                                    key={print}
                                                    src={`/assets/projects/bp/inviprints/${print}`}
                                                    alt={`Printed invitation ${printIndex + 1}`}
                                                    onClick={() => openLightbox(
                                                        invitationPrints.map((invitationPrint) => `/assets/projects/bp/inviprints/${invitationPrint}`),
                                                        printIndex
                                                    )}
                                                    style={{
                                                        width: "100%",
                                                        height: "16em",
                                                        objectFit: "contain",
                                                        borderRadius: "1em",
                                                        cursor: "zoom-in",
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </section>
                    ))}

                    <section className="pictok__mainContainer">
                        <div className="pictok__mainTitle">
                            <h2 style={{ color: "#1f4d3a" }}>Details</h2>
                        </div>
                        <div className="pictok__mainContent">
                              <p>This is an ongoing project that I’m developing into customizable templates using Canva, Adobe Illustrator, Procreate, and Cricut.All images and photographs have been authorized for use and publication.</p>
                        </div>
                    </section>
                    <Lightbox
                        open={lightboxOpen}
                        index={lightboxIndex}
                        close={() => setLightboxOpen(false)}
                        slides={lightboxImages.map((image) => ({ src: image }))}
                        plugins={[Thumbnails]}
                        thumbnails={{
                            position: "start",
                            width: 180,
                            height: 100,
                            borderRadius: 8,
                            gap: 12,
                        }}
                    />
                </div>
            </div>

            <ProjectFooter projectName="bday party" />
        </Transition>
    );
}
